import {AppUrls} from 'shared/config/model/urls';

import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router';
import {t} from '@lingui/core/macro';
import {useDispatch} from 'react-redux';
import {unwrapResult} from '@reduxjs/toolkit';

import {confirmEmail, fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';
import LinkButton from 'shared/ui/Button/LinkButton/LinkButton';
import {getAccessToken, getRefreshToken} from 'shared/api/auth';

import AuthWrapper from './AuthWrapper';

import styles from './Auth.module.scss';

const ConfirmEmail: React.FC = () => {
    const [message, setMessage] = useState<string>();
    const dispatch = useDispatch<TypedDispatch>();
    const {userId, token} = useParams();

    useEffect(() => {
        if (userId && token) {
            dispatch(confirmEmail({userId: Number(userId), token}))
                .then(resultAction => {
                    const response = unwrapResult(resultAction);
                    setMessage(response.message);

                    (getAccessToken() || getRefreshToken()) && dispatch(fetchMe());
                })
                .catch(error => {
                    setMessage(error.message);
                });
        }
    }, [userId, token, dispatch]);

    return (
        <AuthWrapper>
            <div className={styles.title_container}>
                <h2 className={styles.title}>
                    {t`Подтверждение email`}
                </h2>
                {
                    message && <p>{message}</p>
                }
            </div>

            <LinkButton
                href={AppUrls.HOME}
                primary
                block
            >
                {t`Продолжить`}
            </LinkButton>
        </AuthWrapper>
    );
};

export default ConfirmEmail;